export default "__VITE_ASSET__fBWbakmW__"